import React from "react";

const Loader = ({ message = "Loading..." }) => {
  return (
    <div className="loader-overlay">
      <div className="spinner"></div>
      <p>{message}</p>
      <style>{`
        .loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }
        .spinner {
          width: 50px;
          height: 50px;
          border: 5px solid transparent; /* Transparent border */
          border-top: 5px solid #3357ff; /* Solid color */
          border-right: 5px solid #3357ff; /* Add color to the right */
          border-bottom: 5px solid #3357ff; /* Add color to the right */
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        p {
          margin-top: 1rem;
          font-size: 1.2rem;
          color: #ffffff; /* White text */
          font-weight: bold;
        }
      `}</style>
    </div>
  );
};

export default Loader;
